import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { api } from '../services';

/**
 * hook para remover un usuario mediante email de la lista de grupo de la cuenta
 */
const useRemoveUserGroup = ({ setOpen, setSearchData }) => {
  const currentToken = useSelector(({ login }) => login.token);
  const [email, setEmail] = useState('');
  const [loadingHook, setLoadingHook] = useState(false);
  const [message, setMessage] = useState(null);
  const { removeGroupMembers } = api();

  const handleSubmit = useCallback(
    event => {
      setMessage('');
      setLoadingHook(true);
      if (event) {
        event.preventDefault();
      }
      if (email === '') {
        setMessage('se debe ingresar el email');
        return false;
      }
      const submit = async () => {
        try {
          const { data } = await removeGroupMembers(currentToken, email);
          // console.debug('data adduser', data);
          if (data.ok) {
            setSearchData(true);
            setOpen(false);
          } else {
            setMessage('Error al guardar usuario');
          }
        } catch (error) {
          setMessage('Error al guardar usuario');
        } finally {
          setLoadingHook(false);
        }
      };
      submit();
    },
    [email, removeGroupMembers]
  );

  const handleSet = email => {
    setEmail(email);
    setMessage('');
    // console.debug('setemail', email);
  };

  return {
    handleSubmit,
    handleSet,
    message,
    email,
    loadingHook,
  };
};

export default useRemoveUserGroup;
